import type { PropsWithChildren } from 'react';

import { type SizingProps } from '@material-ui/system'

import { PdfViewerStyled } from './styles/PdfViewerStyled'

export interface IPdfViewerProps extends SizingProps {
  data: string
}

export const PdfViewer = ({
  data,
  children,
  ...otherProps
}: PropsWithChildren<IPdfViewerProps>) => {
  return (
    <PdfViewerStyled {...otherProps}>
      <object
        width='100%'
        height='100%'
        type='application/pdf'
        aria-label='PDF'
        data={data}
      >
        {children}
      </object>
    </PdfViewerStyled>
  )
}

PdfViewer.defaultProps = {}
PdfViewer.displayName = 'PdfViewer'
